/** fileName: LocationChangeMonitor.js
 * developer: majid.garavand@gmail.com
 * created: 3/17/23
 * note: Do not delete this comment to maintain copyright rules
 * */
import React, {useEffect, useState} from 'react';
import {SetState} from "../../redux/reduxhelper";
import {PAGE_TITLE} from "../../redux/action/type.action";
import {useDispatch} from "react-redux";

const LocationChangeMonitor = ({onChange = null, children}) => {
    const [docLocation, setDocLocation] = useState('');
    let tmr = null;
    const listenToDoc = () => {
        tmr = setInterval(() => {
            if (document.location.pathname !== docLocation) {
                // console.log('document.location.pathname','loc:'+document.location.pathname,'docLocation:'+docLocation)
                setDocLocation(document.location.pathname);
            }
        }, 300)
    }

    const dispatch = useDispatch();

    useEffect(() => {
        listenToDoc()
    }, [])


    useEffect(() => {
        // clearInterval(tmr);
        if (onChange) onChange();
        setTimeout(()=>{
            let title = document.head.getElementsByTagName("title")[0].innerHTML ?? 'unknown';
            dispatch(SetState(PAGE_TITLE, title));
        },200)

    }, [docLocation])
    return (
        <>
            {children}
        </>
    );
};

export default LocationChangeMonitor;